import { Injectable, inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { BehaviorSubject, Observable, of, tap } from 'rxjs'
import { environment } from '../../environments/environment'
import { UserDto } from '../models/user-dto'

@Injectable({
    providedIn: 'root',
})
export class UserService {
    private readonly http = inject(HttpClient);

    isAdmin: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(undefined)
    private isAdminFetched: boolean = false
    private isAdminRequestInProgress: boolean

    fetchIsAdmin(): Observable<void> {
        if (this.isAdminFetched) {
            return of(undefined)
        }

        if (this.isAdminRequestInProgress) {
            return this.waitForRequestToFinish()
        }

        this.isAdminRequestInProgress = true
        const path = `${environment.baseUrl}/users/is-admin`
        return of(undefined).pipe(
            tap(() => {
                this.http.get<UserDto>(path).subscribe({
                    next: (resp) => this.isAdmin.next(resp?.admin),
                    error: () => this.isAdmin.next(false),
                    complete: () => {
                        this.isAdminRequestInProgress = false
                        this.isAdminFetched = true
                    },
                })
            }),
        )
    }

    private waitForRequestToFinish(): Observable<any> {
        return new Observable((observer) => {
            const interval = setInterval(() => {
                if (!this.isAdminRequestInProgress) {
                    clearInterval(interval)
                    observer.next(null)
                    observer.complete()
                }
            }, 100)
        })
    }
}
